import { Component, OnInit } from '@angular/core';
import { AnnouncementApiService } from '../../../services/api/announcement-api.service';
import { IAnnouncement } from '../../../types/website-builder/announcement';
import { ModalBaseComponent } from '../../../components/modal-base/modal-base.component';
import { IModalComponent } from '../../../types/modal/modal-base';
import { ModalButton } from '../../../types/modal/modal-button';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'announcements-view-modal',
  templateUrl: './announcements-view-modal.component.html',
  styleUrls: ['./announcements-view-modal.component.scss']
})
export class AnnouncementsViewModalComponent implements OnInit, IModalComponent {

  /**
   * Modal base component
   */
  baseComponent: ModalBaseComponent;

  buttons: ModalButton[] = [
    new ModalButton('Close', null),
  ];

  data: {noticeId: string};

  title: string;

  notice: IAnnouncement;

  safeNoticeText: SafeHtml;

  constructor(
      private announcementApi: AnnouncementApiService,
      private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.announcementApi.getNotice(this.data.noticeId).subscribe(notice => {
      this.baseComponent.title = notice.title;
      this.notice = notice;
      this.safeNoticeText = this.notice.text ? this.sanitizer.bypassSecurityTrustHtml(this.notice.text) : null;
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/views/announcements/announcements-view-modal/announcements-view-modal.component.ts